import { Button, Icon, Skeleton } from '@chikara/ui';
import { MfaQrProps } from '@/features/auth/types/mfa.types';
import { t } from '@/i18n';
import styles from './MfaValidation.module.css';


export function MfaQr({ qrCode, manualCode, error, onRetry, onContinue, onReturn }: MfaQrProps) {
	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h2 className={styles.title}>{t('mfaQr.title')}</h2>
				<p className={styles.subTitle}>{t('mfaQr.subtitle')}</p>
			</div>

			<div className={styles.qrContainer}>
				{qrCode ? (
					<img className={styles.imgQr} src={qrCode} alt="QR MFA" />
				) : (
					<Skeleton width="180px" height="180px" variant="rectangle" className={styles.imgQr} />
				)}
			</div>

			<p className={styles.lightText}>
				<span className={styles.block}>{t('mfaQr.helpTitle')}</span>
				<span className={styles.block}>{t('mfaQr.helpAction')}</span>
			</p>

			{manualCode && <p className={styles.boldText}>{manualCode} <Icon name="information" size="md" /></p>}

			{error && <p style={{ color: 'red' }}>{error}</p>}

			<Button className={styles.submitButton} onClick={onContinue}>
				{t('mfaQr.action')}
			</Button>
			{error && <Button variant="secondary" className={styles.submitButton} onClick={onRetry}>
				Reintentar QR
			</Button>}
			<Button variant="secondary" className={styles.submitButton} onClick={onReturn}>
				{t('mfaQr.return')}
			</Button>
		</section>
	);
}
